import { addMonths, format, getDaysInMonth, subMonths } from "date-fns";
import { useEffect, useState } from "react";
import { getCalendarProjects } from "@/api/projects";
import { CalendarProps } from "@/interfaces/calendar_type";
import { OrangeButton, RouteButton } from "../../Buttons";
import { FullCalendar } from "./FullCalendar";

export function MonthlyCalendar({
	userProjectsOnly = false,
}: {
	userProjectsOnly?: boolean;
}) {
	const [currentMonth, setCurrentMonth] = useState(new Date());

	const [projectsDueThisMonth, setProjectsDueThisMonth] = useState<
		CalendarProps[]
	>([]);
	const daysInMonth = getDaysInMonth(currentMonth);

	//*** Handles month navigation
	const handlePrevMonth = () => {
		setCurrentMonth(subMonths(currentMonth, 1));
	};

	const handleNextMonth = () => {
		setCurrentMonth(addMonths(currentMonth, 1));
	};

	useEffect(() => {
		const fetchProjects = async () => {
			try {
				const response = await getCalendarProjects(
					"month",
					format(currentMonth, "yyyy-MM-dd"),
					userProjectsOnly,
				);

				setProjectsDueThisMonth(response.days);
			} catch (error) {
				console.error("Server Error: ", error);
			}
		};
		fetchProjects();
	}, [currentMonth, userProjectsOnly]);

	//max-w-md my-5 mx-auto bg-slate-200 rounded-lg shadow-md p-6
	return (
		<>
			<div className="flex justify-center gap-4">
				<OrangeButton
					onClick={() => setCurrentMonth(new Date())}
					className="p-4 transition bg-orange-300 rounded hover:bg-orange-400"
				>
					Go to Today
				</OrangeButton>

				<RouteButton
					route={
						userProjectsOnly ? "/calendar/weekly/user" : "/calendar/weekly"
					}
					text="Switch to Weekly Calendar"
				/>
			</div>

			<FullCalendar
				currentMonth={currentMonth}
				handlePrevMonth={handlePrevMonth}
				handleNextMonth={handleNextMonth}
				daysInMonth={daysInMonth}
				projectsDueToday={projectsDueThisMonth}
			/>
		</>
	);
}
